import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { FC, ReactNode, useCallback } from 'react';

import { IAlertAtomProps } from '../atom';

export interface IAlertDialogProps extends Omit<IAlertAtomProps, 'message'> {
  onClose: () => void;
  children: ReactNode | ReactNode[];
}

export const AlertDialog: FC<IAlertDialogProps> = props => {
  const { onClose, children, open, title, confirmBtnLabel } = props;

  const onAlertHandler = useCallback(() => {
    onClose();
  }, [onClose]);

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle
        sx={{
          color: theme => theme.palette.common.white,
          backgroundColor: 'primary.main',
          textAlign: 'center',
          fontWeight: 600,
          px: 3,
          py: 2,
        }}
      >
        {title}
      </DialogTitle>
      <DialogContent>
        <DialogContentText>{children}</DialogContentText>
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <Button
          sx={{
            minWidth: 'auto',
            textAlign: 'center',
            py: 1.2,
            px: 7,
          }}
          onClick={onAlertHandler}
          autoFocus
        >
          {confirmBtnLabel ?? 'Ok'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
